<template>
  <div
    v-if="canSelectSeason && availableSeasons.length > 1"
    class="season-selector"
    :class="{ 'is-past': isViewingPastSeason }"
    title="View a past season (read-only)"
  >
    <i class="bi bi-calendar3 season-selector__icon" aria-hidden="true"></i>
    <select
      class="season-selector__select"
      :value="currentValue"
      @change="onChange($event.target.value)"
    >
      <option
        v-for="s in availableSeasons"
        :key="s.season_year"
        :value="s.season_year"
      >
        {{ s.label }}{{ s.is_current ? " (current)" : "" }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SeasonSelector",
  computed: {
    ...mapGetters([
      "availableSeasons",
      "selectedSeasonYear",
      "selectedSeason",
      "isViewingPastSeason",
      "canSelectSeason",
    ]),
    // The dropdown shows the past season when overriding, otherwise the
    // current season so the control is never blank.
    currentValue() {
      if (this.selectedSeasonYear) return this.selectedSeasonYear;
      const current = this.availableSeasons.find((s) => s.is_current);
      return current ? current.season_year : "";
    },
  },
  watch: {
    // The user profile loads asynchronously, so canSelectSeason is
    // commonly false when this component first mounts. A `mounted()`
    // one-shot would miss the transition to true and the picker
    // would never populate — the selector then silently hides itself
    // because `availableSeasons.length > 1` is also false.
    // immediate:true covers the case where the profile is already
    // in the store on remount.
    canSelectSeason: {
      immediate: true,
      handler(canSelect) {
        if (canSelect) this.fetchSeasons();
      },
    },
  },
  methods: {
    ...mapActions(["fetchSeasons", "selectSeason"]),
    onChange(seasonYear) {
      if (seasonYear === this.currentValue) return;
      this.selectSeason(seasonYear); // triggers a reload
    },
  },
};
</script>

<style scoped>
.season-selector {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: #fff;
}

.season-selector.is-past {
  border-color: #fd7e14;
  background: #fff4e8;
}

.season-selector__icon {
  font-size: 0.85rem;
  color: #6c757d;
}

.season-selector.is-past .season-selector__icon {
  color: #fd7e14;
}

.season-selector__select {
  border: none;
  background: transparent;
  font-size: 0.85rem;
  font-weight: 600;
  color: #343a40;
  cursor: pointer;
  outline: none;
  padding-right: 2px;
}

.season-selector.is-past .season-selector__select {
  color: #fd7e14;
}
</style>
